<admin-nav [title]="'Localization'"></admin-nav>
<div class="bk-admin__page">

    <div class="bk-data-table__weather-stations">
        <div class="bk-data-table__head">
            <div class="bk-data-table__search">
                <label class="bk-data-table__search--label">
                    {{ 'Filter By' | translate }}
                     <input class="bk-data-table__search--input"
                        (keyup)="search($event.target.value)"
                        placeholder="Name"/>
                </label>
            </div>
            <button class="bk-button bk-data-table__title--button-right"
                (click)="create()">
                <span class="bk-data-table__plus-icon">+</span> 
                {{'Add' | translate }} {{'System Label' | translate }}
            </button>
        </div>

        <!-- table START -->

        <div class="bk-data-table__content">
            <mat-table [dataSource]="dataSource" matSort>

                <ng-container matColumnDef="keyword">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{ 'System Label' | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row">
                        {{row.keyword}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="en-us">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{ 'English (United States)' | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row">
                        {{row['en-us']}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="es">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{ 'Spanish' | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row">
                        {{row.es}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Action">
                    <mat-header-cell *matHeaderCellDef>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row"
                        class="bk-data-table__cell-overflow">
                        
                        <button type="button"
                            class="bk-button bk-admin__button"
                            (click)="edit(row)">
                            {{ 'Edit' | translate }}
                        </button>

                        <button type="button"
                            class="bk-button bk-admin__button"
                            (click)="delete(row)">
                            {{ 'Delete' | translate }}
                        </button>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

            </mat-table>

            <mat-paginator [pageSizeOptions]="[10, 25, 50]"></mat-paginator>
        </div>
    </div>
</div>
